import { TranslateService } from '@ngx-translate/core';
import { Component } from '@angular/core';
import { IntlService } from '@progress/kendo-angular-intl';
import { MemberService } from 'src/app/core/service/member.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { MemberEligibility } from 'src/app/member/model/member';

@Component({
  selector: 'app-patient-eligibility',
  templateUrl: './patient-eligibility.component.html',
  styleUrls: ['./patient-eligibility.component.scss']
})
export class PatientEligibilityComponent 
{
  public eligibilityOpened = false;
  public eligibilityData: any = '';

  constructor(
    private memberService: MemberService,
    private translate: TranslateService,
    private messageHandlerService: MessageHandlerService,
    public intl: IntlService) { }

  public execute(memberId: number): void
  {
    this.memberService.checkMemberEligibility(memberId).subscribe({
      next: (eligibility: MemberEligibility) =>
      {
        if (eligibility)
        {
          if (eligibility.medicaidMissing)
          {
            this.messageHandlerService.displayDirectMessage('warning', this.translate.instant('MEDICAID-NOT-SET-FOR-PATIENT').replace('{{name}}', eligibility.patientName));
          }
          else
          {
            this.eligibilityData = eligibility;
            this.eligibilityOpened = true;
          }
        }
      },
      error: (errorMessage) =>
      {
        this.messageHandlerService.displayError(errorMessage);
      }
    });
  }

  public closeEligibility(): void
  {
    this.eligibilityOpened = false;
  }
}
